import { Languages } from '@framework/constants/enums/languages';

const useLanguages = () => {
    return [
        { key: 'English', name: 'English', value: Languages.English },
        { key: 'German', name: 'Deutsch', value: Languages.German },
        { key: 'French', name: 'Français', value: Languages.French },
        { key: 'Italian', name: 'Italiano', value: Languages.Italian },
        { key: 'Dutch', name: 'Nederlands', value: Languages.Dutch },
        { key: 'Swedish', name: 'Svenska', value: Languages.Swedish }
    ];
};

export default useLanguages;
